export const TRANSLATION_KEY = 'transaction-monitoring';

export const PATHS = {
  TRANSACTION_MONITORING: '/transaction-monitoring',
  TRANSACTION_MONITORING_RESULTS: '/transaction-monitoring-results',
  TRANSACTION_MONITORING_ADDRESS_REPORT: ':id',
  TRANSACTION_MONITORING_ADDRESS_REPORT_LOGS: ':id/logs',
  ENTITY_EXPLORER: '/entity-explorer',
  ENTITY_EXPLORER_DETAILS: '/entity-explorer/:entityId',
};

export const BLOCKCHAINS = {
  BTC: 'BTC',
  BSV: 'BSV',
  ETH: 'ETH',
  LTC: 'LTC',
  TRON: 'TRON',
  POLYGON: 'POLYGON',
  ARBITRUM: 'ARBITRUM',
  BNB: 'BNB',
  BASE: 'BASE',
  AVALANCHE: 'AVALANCHE',
  MOONBEAM: 'MOONBEAM',
  SOLANA: 'SOLANA',
  DOT: 'DOT',
  TON: 'TON',
  CARDANO: 'CARDANO',
  WORLDCOIN: 'WORLDCOIN',
};

const advancedBlockchains = [
  BLOCKCHAINS.BTC,
  BLOCKCHAINS.BSV,
  BLOCKCHAINS.ETH,
  BLOCKCHAINS.BNB,
  BLOCKCHAINS.LTC,
  BLOCKCHAINS.TRON,
  BLOCKCHAINS.AVALANCHE,
  BLOCKCHAINS.CARDANO,
  BLOCKCHAINS.WORLDCOIN,
];

export const essentialBlockchains = [
  BLOCKCHAINS.POLYGON,
  BLOCKCHAINS.ARBITRUM,
  BLOCKCHAINS.BNB,
  BLOCKCHAINS.BASE,
  'AVAX',
  'GLMR',
  BLOCKCHAINS.TON,
];

const essentialBlockchainsToMap = [
  BLOCKCHAINS.POLYGON,
  BLOCKCHAINS.ARBITRUM,
  BLOCKCHAINS.BASE,
  BLOCKCHAINS.DOT,
  BLOCKCHAINS.SOLANA,
  BLOCKCHAINS.TON,
];

export const mapBlockchains = (blockchains) =>
  blockchains.map((key) => ({
    value: key,
    label: key,
    icon: `transaction-monitoring:${key.toLowerCase()}`,
  }));

export const searchByOptions = {
  advanced: { name: 'Advanced', options: mapBlockchains(advancedBlockchains) },
  essential: { name: 'Essential', options: mapBlockchains(essentialBlockchainsToMap) },
};

export const STATUSES = {
  UNKNOWN: 'UNKNOWN',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const CRYPTO_AML_TYPE = {
  WALLET: 'WALLET',
  TRANSACTION: 'TRANSACTION',
};

export const blockchainRegex = {
  [BLOCKCHAINS.BSV]: /^(1|3)[a-km-zA-HJ-NP-Z1-9]{25,34}$/,
  [BLOCKCHAINS.BTC]: /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^bc1[a-z0-9]{39,59}$/i,
  [BLOCKCHAINS.ETH]: /^(0x)?[0-9a-fA-F]{40}$/,
  [BLOCKCHAINS.LTC]: /^(L|M)[a-km-zA-HJ-NP-Z1-9]{25,34}$|^ltc1[a-z0-9]{39,59}$/i,
  [BLOCKCHAINS.TRON]: /^(T[1-9A-HJ-NP-Za-km-z]{33})$|^[0-9]{6,8}$/,
  [BLOCKCHAINS.POLYGON]: /^(0x)[0-9A-Fa-f]{40}$/,
  [BLOCKCHAINS.BNB]: /^(0x)[0-9A-Fa-f]{40}$/,
  [BLOCKCHAINS.ARBITRUM]: /^(0x)[0-9A-Fa-f]{40}$/,
  [BLOCKCHAINS.BASE]: /^(0x)[0-9A-Fa-f]{40}$/,
  [BLOCKCHAINS.AVALANCHE]: /^(X-avax)[0-9A-za-z]{39}$|^(0x)[0-9A-Fa-f]{40}$/,
  [BLOCKCHAINS.MOONBEAM]: /^(0x)[0-9A-Fa-f]{40}$/,
  [BLOCKCHAINS.SOLANA]: /^[1-9A-HJ-NP-Za-km-z]{32,44}$/,
  [BLOCKCHAINS.DOT]: /^[1-9A-HJ-NP-Za-km-z]{47,48}$/,
  [BLOCKCHAINS.TON]: /^(?:[EU]Q[0-9A-Za-z_-]{46}|0:[0-9a-fA-F]{64})$/,
  [BLOCKCHAINS.CARDANO]:
    /^(addr1[a-z0-9]{20,}|stake1[a-z0-9]{20,}|(Ae2tdP|DdzFFz)[1-9A-HJ-NP-Za-km-z]{48,104})$/,
  [BLOCKCHAINS.WORLDCOIN]: /^(0x)[0-9A-Fa-f]{40}$/,
};

export const txHashRegex = {
  [BLOCKCHAINS.SOLANA]: /^[1-9A-HJ-NP-Za-km-z]{87,88}$/,
  DEFAULT: /^(0x)?[a-fA-F0-9]{64}$/,
};
